/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OpportunityCoverage
 */
export interface OpportunityCoverage {
  /**
   *
   * @type {number}
   * @memberof OpportunityCoverage
   */
  coveredShipments: number;
  /**
   *
   * @type {number}
   * @memberof OpportunityCoverage
   */
  totalShipments: number;
  /**
   *
   * @type {number}
   * @memberof OpportunityCoverage
   */
  percentage?: number;
  /**
   * Plain description of the service area the coverage was measured against.
   * @type {string}
   * @memberof OpportunityCoverage
   */
  serviceArea?: string;
}

/**
 * Check if a given object implements the OpportunityCoverage interface.
 */
export function instanceOfOpportunityCoverage(
  value: object,
): value is OpportunityCoverage {
  if (!("coveredShipments" in value) || value["coveredShipments"] === undefined)
    return false;
  if (!("totalShipments" in value) || value["totalShipments"] === undefined)
    return false;
  return true;
}

export function OpportunityCoverageFromJSON(json: any): OpportunityCoverage {
  return OpportunityCoverageFromJSONTyped(json, false);
}

export function OpportunityCoverageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OpportunityCoverage {
  if (json == null) {
    return json;
  }
  return {
    coveredShipments: json["coveredShipments"],
    totalShipments: json["totalShipments"],
    percentage: json["percentage"] == null ? undefined : json["percentage"],
    serviceArea: json["serviceArea"] == null ? undefined : json["serviceArea"],
  };
}

export function OpportunityCoverageToJSON(json: any): OpportunityCoverage {
  return OpportunityCoverageToJSONTyped(json, false);
}

export function OpportunityCoverageToJSONTyped(
  value?: OpportunityCoverage | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    coveredShipments: value["coveredShipments"],
    totalShipments: value["totalShipments"],
    percentage: value["percentage"],
    serviceArea: value["serviceArea"],
  };
}
